import * as React from "react";
import { ComponentType } from "react";
import { connect } from "react-redux";
import { Form, actions } from "react-redux-form";
import { routerActions } from "react-router-redux";
import Alert from "react-s-alert";
import ReactTable, { RowInfo } from "react-table";
import { bindActionCreators } from "redux";
import { TrialItemImportBreadcrumbs } from "src/helpers/breadcrumbHelper";
import RouterHoc, { IRouterActions, IRouterProps } from "src/hoc/RouterHoc";
import * as NavigationActions from "../../../actions/navigation";
import * as ToggleActions from "../../../actions/pages/togglePage";
import * as TrialItemImportActions from "../../../actions/trialItemImport";
import { NotificationAlert } from "../../../components/common/index";
import {
    CheckboxFormInput,
    SelectFormInput,
} from "../../../components/form/index";
import { TruncatedCell } from "../../../components/layouts/index";
import {
    FontAwesomeIcon,
    FontAwesomeIcons,
} from "../../../constants/fontAwesomeIcons";
import {
    DEFAULT_PAGE_SIZE,
    PAGE_SIZE_OPTIONS,
} from "../../../constants/reactTableConstants";
import * as Dtos from "../../../dtos/Tmd.dtos";
import { RequestState } from "../../../enumerations/RequestState";
import {
    renderRegistrationFormSaveBlock,
    renderRegistrationFormSaveSuccess,
    renderRegistrationFormSaveWarning,
} from "../../../helpers/alert";
import {
    RegistrationComponent,
    renderFormControls,
} from "../../../helpers/formHelper";
import {
    findLookup,
    generateOptionsFromLookup,
} from "../../../helpers/lookupHelper";
import * as ToggleHelper from "../../../helpers/toggleHelper";
import { RegistrationFormComponent } from "../../../interfaces/forms/IRegistrationComponent";
import { ITmdState } from "../../../reducers/index";
import { TogglePageItem } from "../../../reducers/pages/togglePage";
import { IRegistrationFormState } from "../../../reducers/reactReduxForms/index";
import { ITrialItemImportReduxFormState } from "../../../reducers/reactReduxForms/trialItemImport";
import { TrialLookupsLayout } from "../../index";

import "./TrialItemImportPage.scss";

interface ITrialItemImportPageParams {}

interface ITrialItemImportPageProps
    extends IRouterProps<ITrialItemImportPageParams> {
    form: Dtos.TrialItemImport & IRegistrationFormState;
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    reduxFormState: ITrialItemImportReduxFormState;
    lookups: Dtos.Lookup[];
    validationFailures: Dtos.ResponseError[];
    selectedItems: number[];
    trialItemsByCategory: Dtos.Category[];

    trialId: number;
    sourceTrialId: number;

    // From state
    trialItemImport: Dtos.TrialItemImport;
    loading: boolean;
    loadSuccess: boolean;
    loadFailure: boolean;

    saving: boolean;
    saveSuccess: boolean;
    saveFailure: boolean;

    user: Dtos.User;

    toggleItems: TogglePageItem[];
}

interface ITrialItemImportPageActions extends IRouterActions {
    clear: TrialItemImportActions.ITrialItemImportClearActionCreator;
    load: TrialItemImportActions.ITrialItemImportLoadByIdActionCreator;
    save: TrialItemImportActions.ITrialItemImportSaveActionCreator;

    loadForm: typeof actions.load;
    changeForm: typeof actions.change;
    resetForm: typeof actions.reset;

    navigate: typeof routerActions.push;
    navigateReplace: typeof routerActions.replace;

    toggleExpand: ToggleActions.IToggleExpandedStateActionCreator;

    setBreadcrumbs: NavigationActions.ISetBreadcrumbsActionCreator;
    setDrawerItems: NavigationActions.ISetDrawerItemsActionCreator;

}

type TrialItemImportPageProps = ITrialItemImportPageProps &
    ITrialItemImportPageActions;

const reduxFormName: string = "reduxForms.trialItemImport";
const tableHeaderClass = "btn btn-primary btn-block rounded-0 p-3 d-flex";
const tableStyleClass: React.CSSProperties = {
    textAlign: "left",
    fontWeight: "bold",
    color: "white",
    cursor: "pointer",
};

class TrialItemImportPage extends React.PureComponent<
    TrialItemImportPageProps,
    any
> {
    initialised: boolean;

    constructor(props: TrialItemImportPageProps) {
        super(props);
        this.initialised = false;

        this.clear = this.clear.bind(this);
        this.onCancel = this.onCancel.bind(this);
    }

    componentDidMount() {
        const {
            load,
            trialId,
            trialItemImport,
            setDrawerItems,
            setBreadcrumbs
        } = this.props;

	    

        setDrawerItems([]);
        setBreadcrumbs(TrialItemImportBreadcrumbs());

        if (trialId == undefined || trialId == 0) {
            this.onCancel();
        } else if (trialItemImport) {
            load(trialId, trialItemImport.trialId);
        } else {
            load(trialId, 0);
        }
    }

    componentDidUpdate(prevProps: TrialItemImportPageProps, prevState) {
        const {
            form,
            trialId,
            sourceTrialId,
            load,
            loading,
            loadSuccess,
            saving,
            saveSuccess,
            validationFailures,
            navigate,
            setDrawerItems,
            setBreadcrumbs,
        } = this.props;

        if (!this.initialised) {
            setDrawerItems([]);
            setBreadcrumbs(TrialItemImportBreadcrumbs());
            this.initialised = true;
        }

        if (trialId && prevProps.trialId != trialId) {
            load(trialId, sourceTrialId);
        }

        if (!loading && prevProps.loading) {
            if (loadSuccess) {
                this.loadForm();
            }
        }

        if (!saving && prevProps.saving) {
            if (saveSuccess) {
                if (validationFailures && validationFailures.length > 0) {
                    Alert.warning(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveWarning(
                                validationFailures
                            )}
                            icon={FontAwesomeIcons.Solid.EXCLAMATION_CIRCLE}
                        />
                    );
                } else {
                    Alert.success(
                        <NotificationAlert
                            alertContent={renderRegistrationFormSaveSuccess()}
                            icon={FontAwesomeIcons.Solid.CHECK}
                        />
                    );
                }
                if (form.saveAndReturn) {
                    navigate("/settings/trial/itemtemplates");
                } else {
                    this.loadForm();
                }
            } else {
                Alert.error(
                    <NotificationAlert
                        alertContent={this.renderErrorAlert()}
                        icon={FontAwesomeIcons.Solid.TIMES_OCTAGON}
                    />
                );
            }
        }
    }

    componentWillUnmount() {
        this.clear();
    }

    clear() {
        this.props.clear();
    }

    show(): boolean {
        const { loading, loadSuccess } = this.props;

        if (!loading && loadSuccess) {
            return true;
        }

        return false;
    }

    render() {
        const { loading } = this.props;

        return (
            <TrialLookupsLayout
                loading={loading}
                permission={Dtos.Permission.TrialItemCreate}
            >
                {this.renderContent()}
            </TrialLookupsLayout>
        );
    }

    renderContent() {
        const {
            form,
            lookups,
            validationFailures,
            formProperties,
            formState,
            changeForm,
            trialId,
            selectedItems,
            load,
            saving,
            resetForm,
        } = this.props;

        const formDisabled: boolean =
            saving ||
            (formState && formState.formStatus == Dtos.FormStatus.Disabled);
        const formTrialSelected: boolean =
            !formDisabled && form.trialId && form.trialId > 0;
        const formCanSave: boolean =
            !formDisabled && selectedItems && selectedItems.length > 0;

        let formComponents: { [index: string]: RegistrationFormComponent } = {
            id: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: true,
                inputProps: {
                    options: generateOptionsFromLookup(
                        findLookup("TrialItemImport", "Id", lookups),
                        form.id
                    ),
                },
                inputLabel: "Destination Trial",
            },
            trialId: {
                type: RegistrationComponent.RegistrationControl,
                inputType: SelectFormInput,
                inputDisabled: formDisabled,
                inputProps: {
                    options: generateOptionsFromLookup(
                        findLookup("TrialItemImport", "TrialId", lookups),
                        form.trialId
                    ),
                    placeholder: "Template items",
                },
                inputLabel: "Import templates, or select a source trial",
                changeAction: (model, value, form, parentModel) => {
                    changeForm(model, value);
                    if (value != form.trialId) {
                        resetForm(reduxFormName);
                        load(trialId, value);
                    }
                },
            },
            addGroups: {
                type: RegistrationComponent.RegistrationControl,
                inputType: CheckboxFormInput,
                inputDisabled:
                    formDisabled || !form.trialId || form.trialId == 0,
                inputProps: {
                    label: "Link groups attached to selected items",
                },
                inputLabel: " ",
            },
        };

        return (
            <div className="trail-item-import">
                <h3>Trial Item Import</h3>
                <Form
                    model={reduxFormName}
                    onSubmit={(val, event) => this.handleOnSubmit(val)}
                    onSubmitFailed={(val) => this.handleOnSubmitFailed(val)}
                >
                    <div className="container-fluid">
                        {renderFormControls(
                            form,
                            "trialItemImport",
                            formComponents,
                            lookups,
                            validationFailures,
                            formProperties,
                            changeForm
                        )}
                    </div>
                    {this.show() && (
                        <div className="mt-2">{this.renderTable()}</div>
                    )}
                    <div className="mt-4 mb-4 text-right">
                        <button
                            disabled={!formCanSave}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    false
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit
                        </button>
                        <button
                            disabled={!formCanSave}
                            onClick={() => {
                                this.props.changeForm(
                                    reduxFormName + ".saveAndReturn",
                                    true
                                );
                            }}
                            type="submit"
                            className="btn btn-primary mr-2"
                        >
                            Submit And Return
                        </button>
                        <button
                            onClick={this.onCancel}
                            className="btn btn-primary mr-2"
                        >
                            {" "}
                            Cancel{" "}
                        </button>
                    </div>
                </Form>
            </div>
        );
    }

    renderTable() {
        const {
            trialItemImport,
            trialItemsByCategory,
            toggleItems,
            toggleExpand,
        } = this.props;

        if (!trialItemsByCategory || trialItemsByCategory.length == 0) {
            return (
                <div className="card card-shadow p-3">
                    <div className="alert alert-info d-flex mb-0">
                        <div className="mr-2">
                            <FontAwesomeIcon
                                icon={FontAwesomeIcons.Solid.INFO_SQUARE}
                                fixedWidth
                            />
                        </div>
                        <span>There are currently no items to view.</span>
                    </div>
                </div>
            );
        }

        const showPagination = trialItemsByCategory.length > DEFAULT_PAGE_SIZE;
        const trialItemImportId = trialItemImport ? trialItemImport.id : 0;

        return (
            <div>
                {trialItemsByCategory.map((item, index) => {
                    const key =
                        "trial-items-page-" + item.id + "-" + trialItemImportId;
                    const expanded = ToggleHelper.isToggleExpanded(
                        toggleItems,
                        key
                    );
                    return (
                        <div key={"trial-items-category" + item.id}>
                            <div
                                className={tableHeaderClass}
                                style={tableStyleClass}
                                onClick={() => toggleExpand(key)}
                            >
                                <div>
                                    <FontAwesomeIcon
                                        icon={
                                            !expanded
                                                ? FontAwesomeIcons.Solid
                                                      .ANGLE_DOWN
                                                : FontAwesomeIcons.Solid
                                                      .ANGLE_UP
                                        }
                                        fixedWidth
                                        transform="grow-16"
                                        className="mr-3"
                                    />
                                </div>
                                <span>{item.value}</span>
                            </div>
                            {expanded && (
                                <ReactTable
                                    data={item.trialItems}
                                    pageSizeOptions={PAGE_SIZE_OPTIONS}
                                    defaultPageSize={
                                        showPagination
                                            ? DEFAULT_PAGE_SIZE
                                            : item.trialItems.length
                                    }
                                    pageSize={
                                        showPagination
                                            ? undefined
                                            : item.trialItems.length
                                    }
                                    showPagination={showPagination}
                                    className="-striped -highlight -clickable"
                                    noDataText="There are currently no trial items for this category"
                                    resizable={false}
                                    getTdProps={(
                                        state,
                                        rowInfo: RowInfo,
                                        _column,
                                        _instance
                                    ) => {
                                        return {
                                            onClick: (e, handleOriginal) => {
                                                this.onSelectedItemChanged(
                                                    rowInfo.original.id,
                                                    !this.isItemSelected(
                                                        rowInfo.original.id
                                                    )
                                                );

                                                if (handleOriginal) {
                                                    handleOriginal();
                                                }
                                            },
                                        };
                                    }}
                                    columns={[
                                        {
                                            id: "id",
                                            Header: " ",
                                            accessor: "id",
                                            maxWidth: 50,
                                            Cell: (props) => (
                                                <FontAwesomeIcon
                                                    size="lg"
                                                    icon={
                                                        this.isItemSelected(
                                                            props.value
                                                        )
                                                            ? FontAwesomeIcons
                                                                  .Light.CHECK
                                                            : FontAwesomeIcons
                                                                  .Light
                                                                  .UNCHECKED
                                                    }
                                                    fixedWidth
                                                />
                                            ),
                                        },
                                        {
                                            id: "id",
                                            Header: " ",
                                            accessor: "id",
                                            maxWidth: 50,
                                            Cell: (_props) => (
                                                <FontAwesomeIcon
                                                    size="lg"
                                                    icon={
                                                        FontAwesomeIcons.Light
                                                            .TRIALITEM
                                                    }
                                                    fixedWidth
                                                />
                                            ),
                                        },
                                        {
                                            id: "name",
                                            Header: "Name",
                                            accessor: "name",
                                            Cell: (props) => (
                                                <TruncatedCell
                                                    value={props.value}
                                                />
                                            ),
                                        },
                                        {
                                            id: "description",
                                            Header: "Description",
                                            accessor: "description",
                                            Cell: (props) => (
                                                <TruncatedCell
                                                    value={props.value}
                                                />
                                            ),
                                        },
                                        {
                                            id: "groupDisplay",
                                            Header: "Groups",
                                            accessor: "groupDisplay",
                                            maxWidth: 320,
                                            Cell: (props) => (
                                                <TruncatedCell
                                                    value={props.value}
                                                />
                                            ),
                                        },
                                        {
                                            id: "initialVersion",
                                            Header: "Initial Version",
                                            accessor: "initialVersion",
                                            maxWidth: 220,
                                            Cell: (props) => (
                                                <TruncatedCell
                                                    value={props.value}
                                                />
                                            ),
                                        },
                                    ]}
                                />
                            )}
                        </div>
                    );
                })}
            </div>
        );
    }

    renderErrorAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was <strong> not </strong> saved.
            </div>
        );
    }

    renderWarningAlert(): any {
        const { validationFailures } = this.props;

        return (
            <div>
                The form was saved but was invalid with{" "}
                {validationFailures.length} errors.
            </div>
        );
    }

    renderSaveSuccessAlert(): any {
        return <div>The items hves been successfully saved to the trial</div>;
    }

    handleOnSubmit(data: Dtos.TrialItemImport) {
        const { save } = this.props;

        if (data) {
            let changes: Dtos.TrialItemImport = {} as Dtos.TrialItemImport;
            save(Object.assign({ ...data }, changes));
        }
    }

    handleOnSubmitFailed(_data: Dtos.TrialInstitution) {
        Alert.error(
            <NotificationAlert
                alertContent={renderRegistrationFormSaveBlock()}
                icon={FontAwesomeIcons.Solid.BAN}
            />
        );
    }

    onSelectedItemChanged(id: number, selected: boolean) {
        const { selectedItems, changeForm } = this.props;

        if (selectedItems) {
            let newArray = [...selectedItems];
            var index = newArray.indexOf(id);
            if (selected) {
                // add if not exists
                if (index == -1) {
                    newArray.push(id);
                    changeForm(reduxFormName + ".selectedItems", newArray);
                }
            } else {
                // remove if not exists
                if (index > -1) {
                    newArray.splice(index, 1);
                    changeForm(reduxFormName + ".selectedItems", newArray);
                }
            }
        }
    }

    isItemSelected(id: number) {
        const { selectedItems } = this.props;

        if (selectedItems) {
            var index = selectedItems.indexOf(id);
            return index > -1;
        }
        return false;
    }

    onCancel() {
        const { trialId, navigate } = this.props;

        navigate("/settings/trial/itemtemplates");
    }

    loadForm() {
        const { loadForm, trialItemImport } = this.props;

        let extraData: Dtos.TrialItemImport = {} as Dtos.TrialItemImport;

        loadForm(
            reduxFormName,
            Object.assign({ ...trialItemImport }, extraData)
        );
    }
}

const mapStateToProps = (
    state: ITmdState,
    ownProps: TrialItemImportPageProps
): ITrialItemImportPageProps => {
    return {
        match: ownProps.match,
        form: state.reduxForms.trialItemImport,
        lookups: state.trialItemImport.lookups,
        formState: state.trialItemImport.formState,
        formProperties: state.trialItemImport.formProperties,
        reduxFormState: state.reduxForms.formState.trialItemImport,
        validationFailures: state.trialItemImport.validationFailures,
        selectedItems: state.reduxForms.trialItemImport.selectedItems,
        trialItemsByCategory:
            state.reduxForms.trialItemImport &&
            state.reduxForms.trialItemImport.templateCategories
                ? state.reduxForms.trialItemImport.templateCategories
                : [],

        trialId: state.trialSettingsPage.trialId,
        sourceTrialId: state.reduxForms.trialItemImport
            ? state.reduxForms.trialItemImport.trialId
            : undefined,

        history: ownProps.history,
        location: ownProps.location,

        trialItemImport: state.trialItemImport.formData,

        loading:
            state.trialItemImport.loadState &&
            state.trialItemImport.loadState.status == RequestState.Pending,
        loadSuccess:
            state.trialItemImport.loadState &&
            state.trialItemImport.loadState.status == RequestState.Success,
        loadFailure:
            state.trialItemImport.loadState &&
            state.trialItemImport.loadState.status == RequestState.Failure,

        saving:
            state.trialItemImport.saveState &&
            state.trialItemImport.saveState.status == RequestState.Pending,
        saveSuccess:
            state.trialItemImport.saveState &&
            state.trialItemImport.saveState.status == RequestState.Success,
        saveFailure:
            state.trialItemImport.saveState &&
            state.trialItemImport.saveState.status == RequestState.Failure,

        user: state.user.data,

        toggleItems: state.togglePage.items,
    };
};

const mapDispatchToProps = (
    dispatch,
    ownProps: TrialItemImportPageProps
): ITrialItemImportPageActions => {
    return {
        navigate: ownProps.navigate,
        navigateReplace: ownProps.navigateReplace,

        load: bindActionCreators(TrialItemImportActions.Load, dispatch),
        clear: bindActionCreators(TrialItemImportActions.Clear, dispatch),
        save: bindActionCreators(TrialItemImportActions.Save, dispatch),

        loadForm: bindActionCreators(actions.load, dispatch),
        changeForm: bindActionCreators(actions.change, dispatch),
        resetForm: bindActionCreators(actions.reset, dispatch),

        toggleExpand: bindActionCreators(
            ToggleActions.ToggleExpanded,
            dispatch
        ),

        setBreadcrumbs: bindActionCreators(
            NavigationActions.SetBreadcrumbs,
            dispatch
        ),
        setDrawerItems: bindActionCreators(
            NavigationActions.SetDrawerItems,
            dispatch
        )
    };
};

export default RouterHoc<ITrialItemImportPageParams, TrialItemImportPageProps>(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(TrialItemImportPage) as unknown as ComponentType<TrialItemImportPageProps>
) as ComponentType<any>;
